import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchQuestionnaireSubmissionsForUser,
  fetchQuestionnaireSubmissionById,
  fetchPendingQuestionnaireSubmissions,
} from '../api/questionnaireSubmissions.api';

export const questionnaireSubmissionsQueryKeys = createQueryKeys(
  'questionnaireSubmissions',
  {
    fetchById: ({
      organizationId,
      id,
    }: {
      organizationId?: string;
      id: string;
    }) => ({
      queryFn: () => fetchQuestionnaireSubmissionById({ organizationId, id }),
      queryKey: [id, organizationId],
    }),
    fetchForUser: ({
      organizationId,
      userId,
    }: {
      organizationId?: string;
      userId: string;
    }) => ({
      queryFn: () =>
        fetchQuestionnaireSubmissionsForUser({ organizationId, userId }),
      queryKey: [userId, organizationId],
    }),
    fetchPending: () => ({
      queryFn: () => fetchPendingQuestionnaireSubmissions(),
      queryKey: ['pending'],
    }),
  },
);
